import script from "./drug-form.vue?vue&type=script&setup=true&lang=tsx"
export * from "./drug-form.vue?vue&type=script&setup=true&lang=tsx"

import "./drug-form.vue?vue&type=style&index=0&id=68fa9008&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68fa9008"]])

export default __exports__